import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AnimationProvider } from "./components/AnimationContext";
import { WebSocketProvider } from "./components/WebSocketContext";
import { GlobalStyle } from "./GlobalStyle";
import { Layout } from "./components/Layout";
import { TransferPage } from "./pages/TransferPage";
import { ProgressPage } from "./pages/ProgressPage";
import { AdminPage } from "./pages/AdminPage";

import { ErrorBoundary } from "./components/ErrorBoundary";

function App() {
  return (
    <AnimationProvider>
      <GlobalStyle />
      <ErrorBoundary>
        <WebSocketProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/transfer" replace />} />
                <Route path="/transfer" element={<TransferPage />} />
                <Route path="/swap" element={<TransferPage />} />
                {/* <Route path="/trade" element={<TradePage />} /> */}
                {/* <Route path="/spark" element={<SparkPage />} /> */}
                <Route path="/progress" element={<ProgressPage />} />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </Layout>
          </Router>
        </WebSocketProvider>
      </ErrorBoundary>
    </AnimationProvider>
  );
}

export default App;
